
import { XMarkIcon } from '@heroicons/react/24/outline'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import Spinner from '../../../Componenten/Spinner'
import { Attachments } from '../../../Componenten/Documenten/Attachments'
import VragenlijstenResumer from '../../../Componenten/Vragenlijsten/VragenlijstenResumer'
import { useLayoutEffect, useState } from 'react'
import { AXIOS_GET } from '../../../server/api/crud'
import Commentaar from '../../../Componenten/Commentaar'
import { getUserdetails } from '../../../Localstorage/localstorage'
import RP_Avatar from '../../../Componenten/RP_Avatar'


  const eventTypes = {
    applied: { icon: XMarkIcon, bgColorClass: 'bg-red-400' },
    advanced: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
    completed: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
  }
  
  const timeline = [
    {
      id: 1,
      type: eventTypes.applied,
      content: 'Pre-intake formulier',
      target: 'Niet ingevuld',
      date: 'Sep 20',
      datetime: '2020-09-20',
    },
    {
      id: 2,
      type: eventTypes.advanced,
      content: 'Klachtenregistratie formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    },
    {
      id: 3,
      type: eventTypes.advanced,
      content: 'VoedingsDagboek formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    }
  ]

  const CalculateAge = ( birthDate ) => {
    // Get the current date
    const currentDate = moment();
    
    // Create a moment object for the birthdate
    const birthDateMoment = moment(birthDate, 'YYYY-MM-DD'); // Adjust format as needed

    // Calculate the age
    const age = currentDate.diff(birthDateMoment, 'years');
    
    return age
  };
  
  const DetailProfiel = () => {

    const usernav = useLocation();
    const {user} = usernav?.state;
    const [attachments, setAttachments] = useState([])
    const [, setVragenlijst] = useState(null)

    const userAdmin = getUserdetails();
    const infoItems = [
      {
        label: "Geregistreerd op",
        value: user?.created_at ? moment(user.created_at).format("LLLL") : "Onbekend",
        accent: true,
      },
      { label: "Email address", value: user?.userdetails_email || "-" },
      { label: "Klacht", value: user?.userdetails_klacht || "-" },
      { label: "Phone", value: user?.userdetails_phone_number || "-" },
    ];

    const getDocumentByID = async (p_user_id) =>{
      await AXIOS_GET(`documents/user/${p_user_id}`).then((res)=>{
          setAttachments(res.data.data)
      })
    }

    const fetchData = async (p_id) => {
      try {
        const response = await AXIOS_GET(`vragenlijsten/${p_id}`);
        setVragenlijst(response.data.data[0])

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    useLayoutEffect(() => {
      if (!user?.user_id) return;
      const { user_id } = user;
      void getDocumentByID(user_id);
      void fetchData(user_id);
    }, [user?.user_id])
    

  if (user) return (
        <div className="min-h-0 bg-wa-app text-wa-text">
          <main className="py-6 sm:py-10">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
              <div className="rounded-2xl border border-wa-border bg-gradient-to-br from-wa-panel via-wa-panel2 to-wa-panel p-5 shadow-[0_20px_60px_-36px_rgba(0,0,0,0.7)] sm:p-6">
                <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-5">
                  <div className="flex min-w-0 items-center gap-4 sm:gap-5">
                  <div className="relative flex-shrink-0 rounded-full ring-2 ring-wa-border">
                    <RP_Avatar avatar={user?.userdetails_avatar} size={16} alt={` ${user?.userdetails_full_name}`} />
                    <span aria-hidden="true" className="absolute inset-0 rounded-full shadow-inner ring-1 ring-wa-border" />
                  </div>
                  <div className="min-w-0">
                    <h1 className="truncate text-2xl font-bold tracking-tight text-wa-text sm:text-3xl">
                      Hallo, {user?.userdetails_full_name}{" "}
                      <span className="text-base font-medium text-wa-muted sm:text-lg">
                        {user?.userdetails_date_of_birth
                          ? `(${CalculateAge(user?.userdetails_date_of_birth)} jaar)`
                          : ""}
                      </span>
                    </h1>
                    <p className="mt-1 text-sm text-wa-muted">
                      <span className="text-wa-text">Geboortedatum</span>{" "}
                      <time dateTime={user?.userdetails_date_of_birth || undefined}>
                        {user?.userdetails_date_of_birth
                          ? moment(user?.userdetails_date_of_birth).format("LL")
                          : "?"}
                      </time>
                    </p>
                  </div>
                </div>
                  <div className="inline-flex items-center rounded-full border border-wa-accent/40 bg-wa-accent/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-wa-accent">
                    Premium profieloverzicht
                  </div>
                </div>
              </div>
            </div>

            <div className="mx-auto mt-6 grid max-w-3xl grid-cols-1 gap-5 px-4 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3 lg:gap-6 lg:px-8">
              <div className="min-w-0 space-y-5 lg:col-span-2 lg:col-start-1">
                <section aria-labelledby="applicant-information-title">
                  <div className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_20px_60px_-36px_rgba(0,0,0,0.7)]">
                    <div className="border-b border-wa-border px-4 py-5 sm:px-6">
                      <h2
                        id="applicant-information-title"
                        className="text-xl font-semibold leading-6 text-wa-text"
                      >
                        Informatie van de patient
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm text-wa-muted">
                        Samenvatting van zijn gehele gezondheidsevolutie
                      </p>
                    </div>
                    <div className="space-y-6 px-4 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        {infoItems.map((item) => (
                          <div
                            key={item.label}
                            className="rounded-xl border border-wa-border bg-wa-panel2/70 p-3.5"
                          >
                            <dt
                              className={`text-[11px] font-semibold uppercase tracking-wide ${
                                item.accent ? "text-wa-accent" : "text-wa-muted"
                              }`}
                            >
                              {item.label}
                            </dt>
                            <dd className="mt-1 break-words text-sm font-medium text-wa-text">
                              {item.value}
                            </dd>
                          </div>
                        ))}
                        <div className="sm:col-span-2">
                          <dt className="text-[11px] font-semibold uppercase tracking-wide text-wa-muted">
                            Situatie
                          </dt>
                          <dd className="mt-1 rounded-xl border border-wa-border bg-wa-panel2/60 p-3.5 whitespace-pre-wrap text-sm text-wa-text">
                            {user?.userdetails_more_details}
                          </dd>
                        </div>
                      </dl>
                      {attachments?.length > 0 && (
                        <div className="border-t border-wa-border pt-6">
                          <Attachments attachments={attachments} />
                        </div>
                      )}
                    </div>
                  </div>
                </section>

                <Commentaar admin={userAdmin} user={user} />
              </div>

              <VragenlijstenResumer
                timeline={timeline}
                vragenlijst={{
                  klacht_verstuur: user?.vragenlijsten_klacht_verstuur,
                  preintake_verstuur: user?.vragenlijsten_preintake_verstuur,
                  voeding_verstuur: user?.vragenlijsten_voeding_verstuur,
                }}
                user={user}
              />
            </div>
          </main>
        </div>
    )

    return(<Spinner/>)
  }

  export default DetailProfiel
